<template>
	<div>
		<div class="content" id="basic-pagination">
			<p>Pagination is enabled by the <code>pagination</code> property:</p>
			<pre v-highlightjs class="box pa-0"><code class="html">&lt;ui-table :items=&quot;items&quot; multisort striped pagination fixed-layout&gt;
	&lt;ui-table-column prop=&quot;group&quot; sortable/&gt;
	&lt;ui-table-column prop=&quot;user&quot;/&gt;
	&lt;ui-table-column prop=&quot;age&quot; sortable/&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<ui-table :items="items" container-class="box" multisort striped pagination fixed-layout>
			<ui-table-column prop="group" sortable/>
			<ui-table-column prop="user"/>
			<ui-table-column prop="age" sortable/>
		</ui-table>
	</div>
</template>

<script>
    export default {
        name: "basic-pagination",
		data() {
            return {
                items: [
                    { group: "foo", user: "User 1", age: 44 },
                    { group: "bar", user: "User 2", age: 21 },
                    { group: "foo", user: "User 3", age: 33 },
                    { group: "foo", user: "User 4", age: 37 },
                    { group: "bar", user: "User 5", age: 55 },
                    { group: "foo", user: "User 6", age: 18 },
                    { group: "bar", user: "User 7", age: 25 },
                    { group: "bar", user: "User 8", age: 61 },
                    { group: "bar", user: "User 9", age: 44 },
                    { group: "bar", user: "User 10", age: 21 }
                ]
			}
		}
    }
</script>